import { TweenMax, TimelineMax } from 'gsap';
import Swiper from '../Swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/csr/pc/');

export default function C(): JSX.Element {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('csr');

    const itemWidth = 300;
    const gap = 40;

    const itemList = [
        {
            img: 'c-1',
            desc: t('secC_list1_desc'),
            link: 'https://blog.ecoflow.com/jp/emergency-supplies/',
        },
        {
            img: 'c-2',
            desc: t('secC_list2_desc'),
            link: 'https://blog.ecoflow.com/jp/teidentaisaku/',
        },
        {
            img: 'c-3',
            desc: t('secC_list3_desc'),
            link: 'https://blog.ecoflow.com/jp/disaster/',
        },
        {
            img: 'c-4',
            desc: t('secC_list4_desc'),
            link: 'https://blog.ecoflow.com/jp/portable-power-station-disaster-prevention/',
        },
        {
            img: 'c-5',
            desc: t('secC_list5_desc'),
            link: 'https://blog.ecoflow.com/jp/camp-items-disaster-prevention/',
        },
    ];

    const handleOpen = (url: string) => window.open(url);

    const items = itemList.map((item: any, index: number) => {
        const style = {
            width: `${itemWidth}px`,
            marginRight: `${gap}px`,
        };

        return (
            <div className={`listItem listItem_${index}`} style={style} onClick={() => handleOpen(item.link)} key={index}>
                <div className="itemImgBox">
                    <EFPic className="itemImg" name={[`${item.img}.webp`, `${item.img}.png`]} />
                </div>
                <div className="itemDesc">{item.desc}</div>
            </div>
        );
    });

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;

        // 轮播图
        const scene = new ScrollMagic.Scene({
            triggerElement: '.csr_pc_C',
            triggerHook: 1,
            offset: 400,
        }).setClassToggle('.csr_pc_C', 'show');

        // 视差
        const viewTL: any = new TimelineMax();
        viewTL.add(
            TweenMax.to(`.csr_pc_C`, 1, {
                paddingBottom: 0,
            }),
            0,
        );

        const viewScene = new ScrollMagic.Scene({
            triggerElement: '.csr_pc_C',
            triggerHook: 1,
            offset: 1500,
            duration: 600,
        }).setTween(viewTL);

        // 右上文字
        const fadeScene = new ScrollMagic.Scene({
            triggerElement: '.csrSwiper',
            triggerHook: 1,
            offset: 100,
        }).setClassToggle('.rightTitle', 'show');

        // 左上内容
        const leftScene = new ScrollMagic.Scene({
            triggerElement: '.csrSwiper',
            triggerHook: 1,
            offset: 0,
        }).setClassToggle('.secC_title', 'show');

        new ScrollMagic.Controller().addScene(scene).addScene(viewScene).addScene(leftScene).addScene(fadeScene);
    }, []);

    const getItems = (str: string): JSX.Element[] => {
        return str.split('').map((font: string, index: number) => {
            return (
                <div key={index} className={`secCFontItem secCFontItem_${index}`}>
                    {font}
                </div>
            );
        });
    };

    const firstLine = getItems(t('secC_title').substr(0, 6));
    const secondLineItems = getItems(t('secC_title').substr(6));

    const lastFontItem = (
        <div className="secCFontItem lastFontItem">
            <div>
                <div className="fontItemLine"></div>
                <div className="fontItemCircleBox">
                    <div className="circleItem">
                        <span className="fontItemCircle"></span>
                    </div>
                    <div className="circleItem">
                        <div className="circleItemLine_1">{t('secC_guide').substr(0, 8)}</div>
                        <div>{t('secC_guide').substr(8)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
    secondLineItems.push(lastFontItem);

    return (
        <div className={`csr_pc_C ${css.csr_pc_C}`}>
            <div className="container cTitleBox">
                <div className="leftTitle">
                    <div className="secC_title fisrtLine">{firstLine}</div>
                    <div className="secC_title secondLine">{secondLineItems}</div>
                </div>
                <div className="rightTitle">{t('secC_text')}</div>
            </div>
            <Swiper className="csrSwiper" itemWidth={itemWidth} gap={gap} btnPosition="bottom" isRightAlign={true}>
                {items}
            </Swiper>
        </div>
    );
}
